class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.mainDetailsSummary = this.mainDetailsToggle.querySelector('summary');
    this.content = this.mainDetailsSummary.nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  get isOpen() {
    return this.mainDetailsToggle.hasAttribute('open');
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', true);
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.isOpen) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.mainDetailsSummary.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.header = document.querySelector('.header-wrapper');
  }

  onMouseEnter() {
    this.open();
    this.mainDetailsToggle.addEventListener('mouseleave', this.onMouseLeave.bind(this));
  }

  onMouseLeave() {
    this.close();
    this.mainDetailsToggle.removeEventListener('mouseleave', this.onMouseLeave);
  }

  onToggle() {
    super.onToggle();

    if (!this.isOpen) {

    }

    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
